import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { unwrapResult } from '@/shared/utils/unwrapResult'
import { resultQueryFn, resultMutationFn } from '@/shared/utils/queryHelpers'
import { queryKeys } from '@/shared/utils/queryKeys'
import { searchTags, fetchPopularTags, fetchTagCategories, fetchTagStats, importTags } from './api'

export function useTagSearch(query: string, limit?: number, category?: number) {
  return useQuery({
    queryKey: queryKeys.tags.search(query, limit, category),
    queryFn: resultQueryFn(() => searchTags(query, limit, category)),
    enabled: query.length >= 1,
    staleTime: 30_000,
  })
}

export function usePopularTags(limit?: number, category?: number) {
  return useQuery({
    queryKey: queryKeys.tags.popular(limit, category),
    queryFn: resultQueryFn(() => fetchPopularTags(limit, category)),
    staleTime: 5 * 60_000,
  })
}

export function useTagCategories() {
  return useQuery({
    queryKey: queryKeys.tags.categories,
    queryFn: resultQueryFn(fetchTagCategories),
    staleTime: 10 * 60_000,
  })
}

export function useTagStats() {
  return useQuery({
    queryKey: queryKeys.tags.stats,
    queryFn: resultQueryFn(fetchTagStats),
    staleTime: 5 * 60_000,
  })
}

export function useImportTags() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => unwrapResult(await importTags()),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
    },
  })
}
